import { Link } from 'react-router-dom';

export const LandingFooter = () => {
  return (
    <footer className="bg-[#2C1810] text-white py-6" data-testid="landing-footer">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Left Side - Copyright */}
          <div className="text-center md:text-left" data-testid="footer-copyright">
            <p className="text-sm text-gray-400">© {new Date().getFullYear()}  IP Protection Associate. All rights reserved.</p>
          </div>

          {/* Right Side - Legal Links */}
          <div className="flex items-center space-x-4 text-sm text-gray-400" data-testid="footer-legal-links">
            <Link
              to="/privacy-policy"
              className="hover:text-[#D4A574] transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <span>|</span>
            <Link
              to="/terms-of-service"
              className="hover:text-[#D4A574] transition-colors"
              data-testid="footer-terms-link"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
